import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

interface Page {
  heading: string;
  route: string;
  svgIcon: string;
  fontIcon: string;
}

interface StoreInfo {
  headerMenu: Array<Page>;
}

@Module
export default class HeaderMenuModule extends VuexModule implements StoreInfo {
  headerMenu = [] as Array<Page> | [];

  /**
   * Get header menu object for current page
   * @returns object
   */
  get getHeaderMenu(): Array<Page> | [] {
    return this.headerMenu;
  }

  @Mutation
  [Mutations.SET_HEADER_MENU_MUTATION](payload) {
    this.headerMenu = payload.headerMenu;
  }

  @Action
  [Actions.SET_HEADER_MENU_ACTION](payload) {
    this.context.commit(Mutations.SET_HEADER_MENU_MUTATION, payload);
  }
}
